function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import isPromise from './isPromise';
var getActionType = function getActionType(type, status) {
  return "".concat(type, "_").concat(status);
};
export var promiseMiddleware = function promiseMiddleware(_ref) {
  var dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      // Dispatched empty action
      if (!action) return action; // Dispatched promise without type propery (e.g. async function)

      if (isPromise(action)) return dispatch({
        type: 'ASYNC_ACTION',
        payload: action
      });
      var type = action.type,
        meta = action.meta,
        _action$payload = action.payload,
        payload = _action$payload === void 0 ? {} : _action$payload; // Dispatched regular action, just pass to the next middleware

      if (!isPromise(payload) && !isPromise(payload.promise)) return next(action); // Handle dispatched promises

      var promise = payload.promise || payload;
      var getPartialAction = function getPartialAction(status) {
        return _objectSpread({
          type: getActionType(type, status)
        }, meta ? {
          meta: meta
        } : {});
      }; // Dispatch the pending action

      next(getPartialAction('START')); // Promise fulfilled handler

      var handleSuccess = function handleSuccess(value) {
        return dispatch(_objectSpread({}, getPartialAction('SUCCESS'), {
          payload: value
        }));
      }; // Promise rejected handler

      var handleError = function handleError(error) {
        return dispatch(_objectSpread({}, getPartialAction('ERROR'), {
          payload: error,
          error: true
        }));
      };
      return promise.then(handleSuccess).catch(handleError);
    };
  };
};
export default promiseMiddleware;